export default __webpack_public_path__ + "static/media/518.82315cf1.png";